import React, { useEffect, useState ,useRef} from "react";
import { useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import "../../App.css";
import { BASE_URL } from "../../utils/config";

import FutureSection from "../../components/360Report/360futuresection";
import OptionSection from "../../components/360Report/360optionsection";
import DeliverySection from "../../components/360Report/360Deliverysection";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Container from "react-bootstrap/Container";
import iconStockmarket from "../../images/icon-stockmarket-01.png";
import { styled } from "@mui/material/styles";
import iconOptions from "../../images/icon-stockmarket-02.png";
import iconDelivery from "../../images/icon-stockmarket-03.png";
import Loading from "../../components/loading";
import Report from "../360report";
import TelegramWidget from "../../components/widget/telegramWidget";

const CreateReport360 = () => {
  const navigate = useNavigate();
  const [eventForm, setEventForm] = useState({
    eventType: "Options",
  });
  const [checked, setChecked] = useState(true);
  const [isFormEditable, setIsFormEditable] = useState(true);
  const imageRef = useRef();
  const [imageName, setImageName] = useState(null);
  const [imageUrl, setimageURL] = useState(null);
  const [base64ImageData, setBase64ImageData] = useState("");
  const [reportDate, setReportDate] = useState({});
  const [loading, setLoading] = useState(false);
  const [futureSectionState, setFutureSectionState] = useState({
    futureReportType: "BUY",
    stockType: "",
    cashCMP: "",
    futureCMP: "",
    futureSL: 0,
    futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
    commentry: "",
    Expiry: "",
    imageData: "",
    volume:''
  });
  const [FutureExpirySelected, setFutureExpirySelected] = useState([]);
  const [FutureStockSelected, setFutureStockSelected] = useState([]);

  const [optionSectionState, setOptionSectionState] = useState({
    optionReportType: "CALL",
    stockType: "",
    optionCMP: "",
    optionSL: 0,
    strikePrice: "",
    underlayingPrice: "",
    optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
    commentry: "",
    Expiry: "",
    volume:''
  });
  const [OptionExpirySelected, setOptionExpirySelected] = useState([]);
  const [OptionStockSelected, setOptionStockSelected] = useState([]);

  const [deliverySectionState, setDeliverySectionState] = useState({
    deliveryReportType: "BUY",
    tradingsymbol: "NSE",
    stockType: "",
    deliveryCmp: "",
    deliveryRemark1: "",
    deliveryRemark2: "",
    deliverySL: "",
    commentry: "",
    Signal: "Buy",
  });
  const [DeliveryStockSelected, setDeliveryStockSelected] = useState([]);
  
  const [stockLossRecord,setStockLossRecord]=useState({});
  const [stockSymbols, setStockSymbols] = useState([]);
  const [NSEstockSymbols, setNSEStockSymbol] = useState([]);
  const [BSEstockSymbols, setBSEStockSymbol] = useState([]);
  let NSEstock = [];
  let BSEstock = [];
  const [commenteryData, setCommenteryData] = useState([]);
  const [request_token, setRequestToken] = useState("");

  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMsz, setErrorMsz] = useState("");
  const [futureError, setFutureError] = useState(false);
  const [optionError, setOptionError] = useState(false);
  const [deliveryError, setDeliveryError] = useState(false);
  const [ApiError, setApiError] = useState(false);

  const [RoleType,setRoleType]=useState('');
  let count = 0;

  useEffect(() => {
    if (count === 0) {
      let roleType = JSON.parse(localStorage.getItem('roleType'));
      
      setRoleType(roleType);
      if(roleType === 'User'){
      
        setEventForm({ ...eventForm, eventType: "Options" });
        getstock("Future");
        getcommentery();
        count += 1;
      }
      else{
        getstock("Future");
        getcommentery();
        count += 1;
      }
    }
  }, []);

  // hanlde future section change
  const handleFutureSectionChange = (newFutureState) => {
  
    setFutureSectionState(newFutureState);
  };

  // handle future expiry change 
  const handleFutureExpirySelect = (newExpirySelected) => {
    setFutureExpirySelected(newExpirySelected);
  };

  //  handle future stock change
  const handleFutureStockSelect = (newStockSelected) => {
 
    setBase64ImageData("");
    setimageURL("");
  };

  //  handle option section change
  const handleOptionSectionChange = (newOptionState) => {
    setOptionSectionState(newOptionState);
  };

  //  handle option expiry change
  const handleOptionExpirySelect = (newExpirySelected) => {
    setOptionExpirySelected(newExpirySelected);
  };

  // handle option expiry chnage
  const handleOptionStockSelect = (newStockSelected) => {
    // console.log("newStockSelected",newStockSelected)
    setOptionStockSelected(newStockSelected);
    setBase64ImageData("");
    setimageURL("");
  };

  // handle delivery section change
  const handleDeliverySectionChange = (newDeliveryState) => {
    setDeliverySectionState(newDeliveryState);
  };

  //  handle delivery stock change
  const handleDeliveryStockSelect = (newStockSelected) => {
    // console.log("newStockSelected", newStockSelected);
    setDeliveryStockSelected(newStockSelected);
    setBase64ImageData("");
    setimageURL("");
  };

  // handle api to call to fetch stock list
  const getstock = async (reportType) => {
  
 
    await fetch(`${BASE_URL}/getstocklist/${reportType}`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then(async (res) => {
      

        if (res.success === true) {
          // if(reportType === 'Delivery'){
          // console.log("inside delivery data")
          let data = res.delvieryData;
          NSEstock = await data.filter((stock) => stock.segment === "NSE");
          // console.log("NSEStockSymbol", NSEstock);
          BSEstock = await data.filter((stock) => stock.segment === "BSE");
          // console.log("BSEStockSymbol", BSEstock);
          if (NSEstock && BSEstock) {
            // console.log("inside last nse and bse");

            setNSEStockSymbol(NSEstock);
            setBSEStockSymbol(BSEstock);
            setStockSymbols(res.data);
            setRequestToken(res.request_token);
            setLoading(false);
          }

          // }else{
          // setStockSymbols(res.data);
          // setRequestToken(res.request_token);
          // setLoading(false);
          // }
        } else {
          setLoading(false);
          setErrorMsz(`Error: ${res.message}`)
          setErrorDialog(true);
          setApiError(true);

          setTimeout(() => {
            setErrorDialog(false);
            setApiError(false);
            setErrorMsz('')
          }, 2000);
        }
      })
      .catch((error) => {
        // Handle errors
        setLoading(false);
        setErrorMsz(`Error: ${error.message}`)
        setErrorDialog(true);
        setApiError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setApiError(false);
          setErrorMsz('');
        }, 2000);
        console.error("Error fetching data:", error);
      });
  };

  // handle fetch commetry record 
  const getcommentery = async () => {
    var eventDate = new Date();
    var day = eventDate.getDate();
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var month = monthNames[eventDate.getMonth()];
    var year = eventDate.getFullYear();

    var formattedDate = day + " " + month + " " + year;
    // console.log("formattedDate", formattedDate);
    let loginuser = JSON.parse(localStorage.getItem("loginData"));
 
    setReportDate(formattedDate);
    await fetch(`${BASE_URL}/getallcommentery`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${loginuser.token}`
      }
    })
      .then((response) => response.json())
      .then((res) => {
        // Process the API response data
        console.log(res.commenteryData);

        if (res.success === true) {
          setCommenteryData(res.commenteryData[0]);
        }else if(res.status === 403){ 
          setErrorMsz(`Error: ${res.message}`)
          setErrorDialog(true);
          setApiError(true);
  
          setTimeout(() => {
            setErrorDialog(false);
            setApiError(false);
            setErrorMsz('');
            localStorage.clear()
            navigate('/login')
          }, 2000);
          
        }
        else if(res.status === 401){
          setErrorMsz(`Error: ${res.message}`)
          setErrorDialog(true);
          setApiError(true);
  
          setTimeout(() => {
            setErrorDialog(false);
            setApiError(false);
            setErrorMsz('');
            localStorage.clear()
            navigate('/login')
          }, 2000);
        }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
        setErrorMsz(`Error: ${error.message}`)
          setErrorDialog(true);
          setApiError(true);
  
          setTimeout(() => {
            setErrorDialog(false);
            setApiError(false);
            setErrorMsz('');
           
          }, 2000);
      });
  };


  // handle select change for option like future option delivery etc
  const handleSelectChange = async (event) => {
    if(event.target.value){
    setLoading(true);
    console.log("seltect option", event.target.value);
    if (event.target.value === "Future") {
      
      setEventForm((prevState) =>{
        const newState = {
          ...prevState,
          eventType:event.target.value,
        };
        return newState;
        });

      setOptionSectionState({
        optionReportType: "CALL",
        stockType: "",
        optionCMP: "",
        optionSL: '0',
        strikePrice: "",
        underlayingPrice: "",
        optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        volume:''
      });
      setDeliverySectionState({
        deliveryReportType: "BUY",
        tradingsymbol: "NSE",
        stockType: "",
        deliveryCmp: "",
        deliveryRemark1: "",
        deliveryRemark2: "",
        deliverySL: '',
        commentry: "",
        Signal: "Buy",
      });

      setimageURL("");
      setBase64ImageData("");
      setIsFormEditable(true);
      setChecked(true);
      setLoading(false);
    }

    if (event.target.value === "Options") {
      
      setEventForm((prevState) =>{
        const newState = {
          ...prevState,
          eventType:event.target.value,
        };
        return newState;
        });

      setFutureSectionState({
        futureReportType: "BUY",
        stockType: "",
        cashCMP: "",
        futureCMP: "",
        futureSL: '0',
        futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        imageData: "",
        base64Data: "",
        volume:''
      });
      setDeliverySectionState({
        deliveryReportType: "BUY",
        tradingsymbol: "NSE",
        stockType: "",
        deliveryCmp: "",
        deliveryRemark1: "",
        deliveryRemark2: "",
        deliverySL: '',
        commentry: "",
        Signal: "Buy",
      });

      setimageURL("");
      setIsFormEditable(true);
      setBase64ImageData("");
      setChecked(true);
      setLoading(false);
    }
    if (event.target.value === "Delivery") {
      setEventForm((prevState) =>{
        const newState = {
          ...prevState,
          eventType:event.target.value,
        };
        return newState;
        });

      setFutureSectionState({
        futureReportType: "BUY",
        stockType: "",
        cashCMP: "",
        futureCMP: "",
        futureSL: '0',
        futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        imageData: "",
        base64Data: "",
        volume:''
      });

      setDeliverySectionState({
        deliveryReportType: "BUY",
        tradingsymbol: "NSE",
        stockType: "",
        deliveryCmp: "",
        deliveryRemark1: "",
        deliveryRemark2: "",
        deliverySL: '',
        commentry: "",
        Signal: "Buy",
      });

      setOptionSectionState({
        optionReportType: "CALL",
        stockType: "",
        optionCMP: "",
        optionSL: 0,
        strikePrice: "",
        underlayingPrice: "",
        optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        volume:''
      });

      setimageURL("");
      setIsFormEditable(true);
      setBase64ImageData("");
      setChecked(true);
      setLoading(false);
    }
    if (event.target.value === "HNI") {
      setEventForm((prevState) =>{
        const newState = {
          ...prevState,
          eventType:event.target.value,
        };
        return newState;
        });

      setFutureSectionState({
        futureReportType: "BUY",
        stockType: "",
        cashCMP: "",
        futureCMP: "",
        futureSL: '0',
        futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        imageData: "",
        base64Data: "",
        volume:''
      });

      setOptionSectionState({
        optionReportType: "CALL",
        stockType: "",
        optionCMP: "",
        optionSL: 0,
        strikePrice: "",
        underlayingPrice: "",
        optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        volume:''
      });

      setDeliverySectionState({
        deliveryReportType: "BUY",
        tradingsymbol: "NSE",
        stockType: "",
        deliveryCmp: "",
        deliveryRemark1: "",
        deliveryRemark2: "",
        deliverySL: '',
        commentry: "",
        Signal: "Buy",
      });
      
      setimageURL("");
      setIsFormEditable(true);
      setBase64ImageData("");
      setChecked(true);
      setLoading(false);
    }
  } 
  };


  // handle submit from 
  const submitForm = async (event) => {
    event.preventDefault();
    setLoading(true);
  

    if (eventForm.eventType === "Future") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        futureSectionState.cashCMP
      );
      const futureCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        futureSectionState.futureCMP
      );
      const futureSLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        futureSectionState.futureSL
      );
      // console.log(futureSectionState, "futureSectionState");

      if (
        futureSectionState.cashCMP === "" ||
        futureSectionState.futureCMP === "" ||
        futureSectionState.futureSL === "" ||
        futureSectionState.stockType === "" ||
        futureSectionState.Expiry === "" ||
        futureSectionState.commentry === ""
      ) {
        // console.log("inside if");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
        // return;
      } else if (!cashCMPIsNumeric) {
        // Your code for the case when all are numeric
        // console.log("inside if cmp");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
        // return; // Terminate the execution

        // generateReport(stock);
      } else if (!futureCMPIsNumeric) {
        // console.log("inside if future cmp");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);

          // alert("Please Enter Valid Details.")
        }, 2000);
        // return; // Terminate the execution
      } else if (!futureSLIsNumeric) {
        // console.log("inside if future sl");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
        // return;
      } else {
        // stock = futureSectionState.stockType;
        // generateReport(stock);
        const matchingStock = stockSymbols.find(
          (stock) => stock.name === futureSectionState.stockType
        );

        console.log("stock", matchingStock);
        generateReport(matchingStock.name, matchingStock.TVExchange);
      }
    } else if (eventForm.eventType === "Options") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.optionCMP
      );
      const optionCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.underlayingPrice
      );
      const optionSLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.optionSL
      );
      const optionStrikepriceIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.strikePrice
      );

      if (
        optionSectionState.optionCMP === "" ||
        optionSectionState.optionSL === "" ||
        optionSectionState.Expiry === "" ||
        optionSectionState.strikePrice === "" ||
        optionSectionState.stockType === "" ||
        optionSectionState.commentry === ""
        // optionSectionState.underlayingPrice === ""
      ) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      }
      // else if (!optionCMPIsNumeric) {
      //   setLoading(false);
      //   setErrorDialog(true);
      //   setOptionError(true);

      //   setTimeout(() => {
      //     setErrorDialog(false);
      //     setOptionError(false);
      //     // alert("Please Enter Valid Details.")
      //   }, 2000);
      // }
      else if (!optionSLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else if (!optionStrikepriceIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else {
        // stock = optionSectionState.stockType;
        // generateReport(stock);

        const matchingStock = stockSymbols.find(
          (stock) => stock.name === optionSectionState.stockType
        );

        console.log("stock", matchingStock);
        generateReport(matchingStock.name, matchingStock.TVExchange);
      }
    } else if (eventForm.eventType === "Delivery") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliveryCmp
      );
      const SLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliverySL
      );
     
      if (
        deliverySectionState.deliveryCmp === "" ||
        deliverySectionState.stockType === "" ||
        deliverySectionState.Signal === "" ||
        deliverySectionState.commentry === ""
      ) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (deliverySectionState.deliverySL === '' && !SLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else {
        // stock = deliverySectionState.stockType;
        // generateReport(stock);
        if (deliverySectionState.tradingsymbol === "NSE") {
          const matchingStock = NSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
          // generateReport('ABINFRA', 'NSE');

        } else {
          const matchingStock = BSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        }
      }
    } else if (eventForm.eventType === "HNI") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliveryCmp
      );
      const SLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliverySL
      );
      // console.log("cashCMPIsNumeric", cashCMPIsNumeric, SLIsNumeric);

      if (
        deliverySectionState.deliveryCmp === "" ||
        deliverySectionState.stockType === "" ||
        deliverySectionState.Signal === "" ||
        deliverySectionState.commentry === ""
      ) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (deliverySectionState.deliverySL === '' && !SLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else {
        // stock = deliverySectionState.stockType;
        // generateReport(stock);
        if (deliverySectionState.tradingsymbol === "NSE") {
          const matchingStock = NSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        } else {
          const matchingStock = BSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        }
      }
    }
  };


  //  handle to generate the report 
  const generateReport = async (stock, stockType) => {
  
  let intervaltime = '1D';
    if(!imageUrl){

      await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}/${intervaltime}`, {
        method: "GET", // or 'POST' or any other HTTP method
        headers: {
          Accept: "image/png",
        },
        responseType: "blob", // Set the responseType to 'blob'
      })
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
         
          const blob = new Blob([buffer], { type: "image/png" });
          let imageurl = URL.createObjectURL(blob);
          setimageURL(imageurl);
  
          if (blob) {
            const uint8Array = new Uint8Array(buffer);
            const base64String = uint8Array.reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            );
            const ImageData = btoa(base64String);
            setBase64ImageData(ImageData)
            if (eventForm.eventType === "Future") {
              setLoading(false);
            }
  
            if (eventForm.eventType === "Options") {
              setLoading(false);
            }
  
            if (eventForm.eventType === "Delivery") {
              setLoading(false);
            }
            if (eventForm.eventType === "HNI") {
              setLoading(false);
            }
          }else{
            setErrorMsz(`Error: Failed to Generate Stock Image.`)
            setErrorDialog(true)
            setApiError(true);
            setTimeout(() => {
              setErrorDialog(false)
              setApiError(false)
              setErrorMsz('')
            }, 2000);

          }
        })
        .catch((error) => {
          console.error("Error fetching image:", error)
          setErrorMsz(`Error: ${error.message}`)
          setErrorDialog(true)
          setApiError(true);
          setTimeout(() => {
            setErrorDialog(false)
            setApiError(false)
            setErrorMsz('')
          }, 2000);
    });
    }
    else if(imageName){
      const base64ImageData = imageUrl.split(",")[1];
        console.log("base 64");
        setBase64ImageData(base64ImageData);

        setTimeout(() => {
          setLoading(false);
      
        }, 2000);
    }
    else{

      setTimeout(() => {
        setLoading(false);
      }, 2000);
     }
  

  };

  // handlecancel funtion is used to cancel the report generation and clear all fields values
  const handleCancel = (event) => {
    event.preventDefault();
    setEventForm({
      eventType: "Future", // Add other fields and their initial values as needed
    });
    setimageURL("");
    setImageName(null);
    setBase64ImageData("");
    setIsFormEditable(true);
    setFutureSectionState({
      futureReportType: "BUY",
      stockType: "",
      cashCMP: "",
      futureCMP: "",
      futureSL: 0,
      futureRemark: "",
      commentry: "",
      Expiry: "",
      imageData: "",
      base64Data: "",
    });

    setOptionSectionState({
      optionReportType: "CALL",
      stockType: "",
      optionCMP: "",
      optionSL: 0,
      strikePrice: "",
      underlayingPrice: "",
      optionRemark: "",
      commentry: "",
      Expiry: "",
    });

    setDeliverySectionState({
      deliveryReportType: "BUY",
      tradingsymbol: "NSE",
      stockType: "",
      deliveryCmp: "",
      deliverySL: '',
      deliveryRemark1: "",
      deliveryRemark2: "",
      commentry: "",
      Signal: "Buy",
    });

    // Add any additional state resetting if needed
  };


  // this function call form child component when send telegram button was pressed
  const handleEventChangeOfTelegram = (newvalue) => {
    console.log("inside handleEventChangeOfTelegram",newvalue)
    setLoading(true)
    setEventForm({ ...eventForm, eventType: "" });
    setIsFormEditable(true);
    setTimeout(() => {
      if (newvalue === "Future") {
        setEventForm({ ...eventForm, eventType: newvalue });
        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: '0',
          futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: '0',
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: '',
          commentry: "",
          Signal: "Buy",
        });
  
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setLoading(false)
        
      } 
      else if(newvalue === "Options") {
        setEventForm({ ...eventForm, eventType: newvalue });
  
        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: '0',
          futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: '0',
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: '',
          commentry: "",
          Signal: "Buy",
        });
  
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setLoading(false)
      }
      else if(newvalue === "Delivery"){
        setEventForm({ ...eventForm, eventType: newvalue });
  
        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: '0',
          futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: '0',
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: '',
          commentry: "",
          Signal: "Buy",
        });
  
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setLoading(false)
      }
      else if(newvalue === "HNI"){
        setEventForm({ ...eventForm, eventType: newvalue });
  
        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: '0',
          futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: '0',
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          Expiry: "",
          volume:''
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: '',
          commentry: "",
          Signal: "Buy",
        });
  
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setLoading(false)
      }
    },200);
 
  };

  // handle toggel change to set telegram true or false to send report on telegram
  const handleChange = (event) => {
    event.preventDefault();
    // console.log("event.target.checked", event.target.checked);
    setChecked(event.target.checked);
  };



  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  //  this function in used to remove image file from parent

  const handleRemoveFileFromChild = () => {
    
    setimageURL(null);
    setBase64ImageData("");
    setImageName(null);
  
  };

  
  const handleStockLossRecordChange = (newRecord)=>{
    setStockLossRecord(newRecord)
  };

  //  this fucntion is used to paste image
  const handlePaste = (e) => {
    e.preventDefault();
    const items = e.clipboardData.items;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.type.indexOf('image') !== -1) {
        // e.preventDefault();
        const file = item.getAsFile();

        setImageName(file.name);
        const reader = new FileReader();
        reader.onloadend = () => {
          // Handle the base64-encoded image
          const base64Image = reader.result;
          // Send the base64-encoded image to the backend using FormData or perform other actions
          console.log(base64Image);
          setimageURL(base64Image);
        };

        reader.readAsDataURL(file);
      }
    }
  };

//  handle image content change using useref
  const handleContentChange = () => {
    imageRef.current.contentEditable = true;
  };

  //  this fucntion call from child compoent and use  to set form not editable
  const handleEditableFromReport = () => {
   
    setIsFormEditable(false);
  };

  return (
    
    <>
      <div className="create-report">
        <Container fluid style={{ padding: "0 40px" }}>
          {loading ? (
            <div
              style={{
                position: "fixed", 
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 class="create-report-heading">Create Report 360</h2>
            <h2 class="Preview-report-heading">Preview Screen</h2>
          </div>
          <div id="divcontent" className="divcontent">
            {/* <img className="img" src={rkblogo} alt="Logo" /> */}

            <form id="eventForm" className="eventForm">
              <div className="options">
                <div>
                  <p className="event-type" htmlFor="eventtype">
                    Select Event Type:
                  </p>

                  <div className="selectbuttons">
             
                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "Future"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconStockmarket} alt="Icon" />
                      <input
                        type="radio"
                        id="future"
                        value="Future"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>Future</p>
                    </div>
                  
                     
                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "Options"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconOptions} alt="Icon" />
                      <input
                        type="radio"
                        id="options"
                        value="Options"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>Option</p>
                    </div>
              
                  
                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "Delivery"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconDelivery} alt="Icon" />
                      <input
                        type="radio"
                        id="delivery"
                        value="Delivery"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>Delivery</p>
                    </div>
                 

                   {RoleType === 'User' ? 
                    null:
                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "HNI"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconDelivery} alt="Icon" />
                      <input
                        type="radio"
                        id="hni"
                        value="HNI"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>HNI</p>
                    </div>
                    }
                  </div>

                  <label htmlFor="withCommentery">With Commentary</label>
                 

                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>
              <div className="form-report">
                {/* Future Buying Section */}
                {eventForm.eventType === "Future" ? (
                  <div id="futurebuyingDiv" className="future">
                    <FutureSection
                      stockSymbols={stockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onFutureSectionChange={handleFutureSectionChange}
                      onFutureExpirySelect={handleFutureExpirySelect}
                      onFutureStockSelect={handleFutureStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      onStockLossRecord={handleStockLossRecordChange}
                    />
                  </div>
                ) : null}

                {/* Option Buying Section */}
                {eventForm.eventType === "Options" ? (
                  <div id="optionbuyingDiv" className="option">
                    <OptionSection
                      stockSymbols={stockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onOptionSectionChange={handleOptionSectionChange}
                      onOptionExpirySelect={handleOptionExpirySelect}
                      onOptionStockSelect={handleOptionStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      onStockLossRecord={handleStockLossRecordChange}
                    />
                  </div>
                ) : null}

                {/* Delivery Report Section */}
                {eventForm.eventType === "Delivery" ? (
                  <div id="deliveryreportDiv" className="report">
                    <DeliverySection
                      stockSymbols={stockSymbols}
                      NSEStockSymbols={NSEstockSymbols}
                      BSEStockSymbols={BSEstockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onDeliverySectionChange={handleDeliverySectionChange}
                      onDeliveryStockSelect={handleDeliveryStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}

                    />
                  </div>
                ) : null}

                {eventForm.eventType === "HNI" ? (
                  <div id="deliveryreportDiv" className="report">
                    <DeliverySection
                      stockSymbols={stockSymbols}
                      NSEStockSymbols={NSEstockSymbols}
                      BSEStockSymbols={BSEstockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onDeliverySectionChange={handleDeliverySectionChange}
                      onDeliveryStockSelect={handleDeliveryStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                    />
                  </div>
                ) : null}

<div className="ReportImagePick" id="stockimageInputDiv">
                  <p>Image:</p>
                  <div
                className="Image-paste-box"
        ref={imageRef}
        contentEditable={imageName}
        onPaste={handlePaste}
        onInput={handleContentChange}

      >
         {imageName ? (
          <div>
            <p style={{width:'100%'}}>Image Name: {imageName}</p>
            
          </div>
        ) : (
          <p style={{width:'100%'}}>Paste an image here...</p>
        )}
                </div>
                </div>
                

                <div className="btndiv">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={submitForm}
                    className="submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          
            <div className="preview-screen">
              {eventForm.eventType === "Future" ? (
                <Report
                  reportChecked={checked}
                  eventType={eventForm.eventType}
                  SectionState={futureSectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={FutureStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}

              {eventForm.eventType === "Options" ? (
                <Report
                  reportChecked={checked}
                  eventType={eventForm.eventType}
                  SectionState={optionSectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={FutureStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}

              {eventForm.eventType === "Delivery" ? (
                <Report
                  reportChecked={checked}
                  eventType={eventForm.eventType}
                  SectionState={deliverySectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={FutureStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}

              {eventForm.eventType === "HNI" ? (
                <Report
                  reportChecked={checked}
                  eventType={eventForm.eventType}
                  SectionState={deliverySectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={FutureStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}
            </div>
           
            <TelegramWidget/>
          </div>

         

          <Dialog
            open={errorDialog}
            onClose={() => {
              setErrorDialog(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div>
                  {futureError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}
                  {optionError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}
                  {deliveryError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}
                  {ApiError ? (
                    <span style={{ color: "black" }}>
                    {errorMsz}
                    </span>
                  ) : null}
                  
                </div>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Container>
      </div>
    </>
  
  );
};

export default CreateReport360;
